module.exports = __webpack_public_path__ + "static/media/tally-logo.1863517c.png";